<template>
  <div class="query" :style="{ height }">
    <img src="@/assets/img/pic_banner.png" alt="" />
    <div class="nav_pos">
      当前位置：
      <label class="index" @click.stop="$router.push('/')">首页</label>
      > 注册入围审核进度查询
    </div>
    <div class="title">
      <span>审核进度查询</span>
      <div class="back_btn" @click="back">
        返回
        <img src="@/assets/img/icon_return.png" alt="" />
      </div>
    </div>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="rule_form">
      <el-form-item label="用户名：" prop="name" label-width="120px"><el-input v-model="ruleForm.name" placeholder="请输入注册账号"></el-input></el-form-item>
      <el-form-item label="手机号码：" prop="phone" label-width="120px">
        <el-input v-model="ruleForm.phone" placeholder="请填写注册手机号码"></el-input>
        <div class="msg_code">短信获取验证码</div>
      </el-form-item>
      <el-form-item label="验证码：" prop="code" label-width="120px"><el-input v-model="ruleForm.code" placeholder="请输入手机验证码"></el-input></el-form-item>
    </el-form>
    <div class="btn_1" @click="submit">审核进度查询</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ruleForm: {
        name: '',
        phone: '',
        code: ''
      },
      rules: {
        name: [{ required: true, message: '请输入注册账号', trigger: 'blur' }],
        phone: [{ required: true, message: '请填写注册手机号码', trigger: 'blur' }],
        code: [{ required: true, message: '请输入手机验证码', trigger: 'blur' }]
      },
      height: document.body.clientHeight - 270 + 'px'
    }
  },
  methods: {
    submit() {
      this.$router.push('/result')
    },
    back() {
      this.$router.push('/')
    }
  }
}
</script>
<style lang="scss" scoped>
.query {
  .btn_1 {
    font-weight: bold;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 25px;
    width: 160px;
  }
  .msg_code {
    border: 1px solid #0774d7;
    color: #0774d7;
  }
}
.query {
  margin-bottom: 100px;
  .title {
    position: relative;
    padding-bottom: 10px;
    text-align: center;
    border-bottom: 1px solid #0774c5;
    span {
      padding: 6px 40px;
      font-weight: bold;
      font-size: 16px;
      color: #0774c5;
      text-align: center;
      border-bottom: 2px solid #0774c5;
    }
    .back_btn {
      bottom: 6px;
    }
  }
}
</style>
